<div class="ui-g-12" style="padding: 0px;">
  <button
    class="float-right btn"
    pButton
    label="{{ 'WORK_HOUR.GENERATE_INVOICE' | translate }}"
    (click)="onGenerateInvoiceButtonClick()"
  ></button>
</div>
